import {
  no_scroll,
  return_scroll
} from '../common/_common';

let movieImg = $('.movieImgBox');
let modal = $('#modal');
let modalInner = $('#modalInner');
let closeBtn = $('#closeBtn');

export function modalFunc() {
  /*
  modal.addClass('open');
*/
  movieImg.on('click', function () {
    modal.addClass('open');
    no_scroll();
    $('body').addClass('noScroll');
    player.mute();
    player.seekTo(0, true);
    player.playVideo();
  });

  closeBtn.on('click', function () {
    modal.removeClass('open');
    return_scroll();
    $('body').removeClass('noScroll');
  });

  modal.on('click', function () {
    if (!$(event.target).closest(modalInner).length) {
      modal.removeClass('open');
      return_scroll();
      $('body').removeClass('noScroll');
    }
  });
}
